import * as RD from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface DialogProps {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title?: string;
  description?: string;
  children: ReactNode;
  maxWidth?: string;
}

export function Dialog({ open, onOpenChange, title, description, children, maxWidth = 'max-w-lg' }: DialogProps) {
  return (
    <RD.Root open={open} onOpenChange={onOpenChange}>
      <RD.Portal>
        <RD.Overlay className="fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <RD.Content
          className={cn(
            'fixed left-1/2 top-1/2 z-50 w-full -translate-x-1/2 -translate-y-1/2 rounded-lg border bg-card p-6 shadow-lg',
            maxWidth
          )}
        >
          {title && <RD.Title className="mb-1 text-lg font-semibold">{title}</RD.Title>}
          {description && <RD.Description className="mb-4 text-sm text-muted-foreground">{description}</RD.Description>}
          {children}
          <RD.Close className="absolute right-4 top-4 rounded-md p-1 text-muted-foreground hover:bg-accent">
            <X className="h-4 w-4" />
          </RD.Close>
        </RD.Content>
      </RD.Portal>
    </RD.Root>
  );
}
